import React from "react";
import DashboardGrid from "./DashboardGrid";
import { TourAlertDialog } from "@/components/tour";
import { useTour } from "@/components/tour";
import { TOUR_STEP_IDS } from "@/lib/tour-constants";
import { useEffect, useState } from "react";

const Dashboard: React.FC = () => {
  const { setSteps, isTourCompleted, setTourPage } = useTour();
  const [openTour, setOpenTour] = useState(false);

  // Set the tour page identifier
  useEffect(() => {
    setTourPage('dashboard');
  }, [setTourPage]);

  useEffect(() => {
    // Set up tour steps for dashboard
    const steps = [
      {
        content: (
          <div>
            <h3 className="font-semibold text-lg mb-2">Left Hand Sidebar Menu</h3>
            <p>This is your left hand menu with all the available options for your tenant to navigate through.</p>
          </div>
        ),
        selectorId: TOUR_STEP_IDS.SIDEBAR_MENU,
        position: "right" as const,
      },
      {
        content: (
          <div>
            <h3 className="font-semibold text-lg mb-2">Home Dashboard</h3>
            <p>This is your home dashboard showing you important stats about your compliance data.</p>
          </div>
        ),
        selectorId: TOUR_STEP_IDS.HOME_BUTTON,
        position: "right" as const,
      },
      {
        content: (
          <div>
            <h3 className="font-semibold text-lg mb-2">Dashboard Content</h3>
            <p>This is your home dashboard showing you important stats about your compliance data.</p>
          </div>
        ),
        selectorId: TOUR_STEP_IDS.DASHBOARD_TITLE,
        position: "bottom" as const,
      },
      {
        content: (
          <div>
            <h3 className="font-semibold text-lg mb-2">Refresh Button</h3>
            <p>This is your refresh button. Click it to refresh your dashboard data.</p>
          </div>
        ),
        selectorId: TOUR_STEP_IDS.REFRESH_BUTTON,
        position: "bottom" as const,
      },
      {
        content: (
          <div>
            <h3 className="font-semibold text-lg mb-2">Live Chat Support</h3>
            <p>Click here for live chat support which can be resumed later via email. You can also view FAQs and help articles here.</p>
          </div>
        ),
        selectorId: TOUR_STEP_IDS.LIVE_CHAT_BUTTON,
        position: "left" as const,
      },
    ];

    setSteps(steps);

    // Auto-start tour if not completed
    const timer = setTimeout(() => {
      if (!isTourCompleted) {
        setOpenTour(true);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [setSteps, isTourCompleted, setTourPage]);

  return (
    <>
      <DashboardGrid />
      <TourAlertDialog isOpen={openTour} setIsOpen={setOpenTour} />
    </>
  );
};

export default Dashboard;
